import { useState, useEffect } from 'react';

export type Breakpoint = 'narrow' | 'medium' | 'wide';

/**
 * Returns a responsive breakpoint based on window width.
 * - wide: > 1200px (full labels)
 * - medium: 900–1200px (icon-only for secondary buttons)
 * - narrow: < 900px (overflow absorbs secondary actions)
 */
export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() => classify(window.innerWidth));

  useEffect(() => {
    const onResize = () => setBp(classify(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}

function classify(w: number): Breakpoint {
  if (w >= 1200) return 'wide';
  if (w >= 900) return 'medium';
  return 'narrow';
}
